// Hide all filter counts in Ride theme
document.addEventListener("DOMContentLoaded", function() {
    function hideCounts() {
        // Select all facet labels that contain the number in parentheses
        const allFilters = document.querySelectorAll('.facet-checkbox__text');
        allFilters.forEach(f => {
            const label = f.querySelector('.facet-checkbox__text-label');
            if (label) {
                // Keep only the label, remove the count
                f.innerHTML = label.innerHTML;
            }
        });
    }

    // Run on initial page load
    hideCounts();

    // Run again after Ride updates filters dynamically (AJAX)
    document.addEventListener('shopify:section:load', hideCounts);
    document.addEventListener('shopify:section:select', hideCounts);
    document.addEventListener('shopify:section:deselect', hideCounts);
});
